import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { MoneyEditButtonProps } from './models';
import editIconBlue from '../../assets/edit-icon-blue.svg';

const defaultDataTestId = 'money-edit-button';

export const MoneyEditButton = styled(
  memo(({ className, amount, sign, onClick: _onClick, dataTestId }: MoneyEditButtonProps) => {
    const onClick = useCallback(() => {
      _onClick({ amount });
    }, [amount]);

    return (
      <div {...{ className, onClick, 'data-testid': dataTestId || defaultDataTestId }}>
        <span className="content">
          {sign}
          {amount}
        </span>
        <img src={editIconBlue} />
      </div>
    );
  })
)`
  ${styles.MoneyEditButton}
`;

MoneyEditButton.defaultProps = {
  sign: '$',
};
